// extracted by mini-css-extract-plugin
export default {"leftCell":"leftCell__uahq24Srlakk"};